export const CACHE_KEY_LIST_SETTINGS = 'settings';
export const SETTINGS_DIALOG = 'terms-cond-dialog';
